import {adminAxios} from '@/Plugins/Axios';

/**
 * admin › ລາຍການ Order ພັດສະດຸ › ຄຳຂໍແກ້ໄຂພັດສະດຸ — every customer update request (receiver / destination /
 * COD), READ ONLY. BFF: api/admin/shipment-update-requests/* (role `service` only; 404 while the feature is off).
 */
const ROOT = 'shipment-update-requests';

const clean = (params = {}) => Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
);

/** Laravel resource collection: {rows: data, meta: {current_page, last_page, total, …}}. */
export async function fetchUpdateRequests(params = {}) {
    const res = await adminAxios.get(ROOT, {params: clean(params)});
    const body = (res && res.data) || {};
    return {rows: Array.isArray(body.data) ? body.data : [], meta: body.meta || null};
}

/** The employee detail shape, UNWRAPPED (its `processed_by` is a bare id; `can_reject` is ignored here). */
export async function fetchUpdateRequest(id) {
    const res = await adminAxios.get(`${ROOT}/${id}`);
    return res.data;
}

/** Branches that have at least one request: [{id, name}]. */
export async function fetchBranchOptions(q) {
    const res = await adminAxios.get(`${ROOT}/branch-options`, {params: clean({q})});
    const data = res && res.data ? res.data.data : null;
    return Array.isArray(data) ? data : [];
}

/** Same filters as the list → .xlsx download. A refusal (422) arrives as JSON inside the blob — see errorMessage. */
export async function downloadExport(params = {}) {
    const res = await adminAxios.get(`${ROOT}/export`, {params: clean(params), responseType: 'blob'});

    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filenameFrom(res.headers['content-disposition'], 'shipment-update-requests.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

function filenameFrom(contentDisposition, fallback) {
    if (!contentDisposition) return fallback;
    const utf8 = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i);
    if (utf8) {
        try {
            return decodeURIComponent(utf8[1].trim());
        } catch (e) {
            return utf8[1].trim();
        }
    }
    const plain = contentDisposition.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1].trim() : fallback;
}

/**
 * The server's message from a failed call: validation `{message, errors}` (first field error) or the
 * envelope `{message, data: {reason}}`. A blob request carries the JSON as a Blob, so it is read first.
 */
export async function errorMessage(error, fallback) {
    let data = error && error.response && error.response.data;
    if (data instanceof Blob) {
        try {
            data = JSON.parse(await data.text());
        } catch (e) {
            data = null;
        }
    }
    if (data && data.errors) {
        const first = Object.values(data.errors).flat()[0];
        if (first) return first;
    }
    return (data && data.message) || fallback;
}
